import React from 'react';
import {
  Button, SimpleForm,AutocompleteArrayInput, SelectArrayInput, ReferenceArrayInput, Toolbar,
  TextField, Datagrid, Edit, Create, List, DateField, Filter, TextInput, SaveButton, required,
  FormDataConsumer, useListContext, CreateButton} from 'react-admin';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import CloudDownload from '@material-ui/icons/CloudDownload';
import DataTable from 'react-data-table-component';
import { fetchUtils } from 'react-admin';
import { Typography } from "@material-ui/core";
import { ExpandMore } from '@material-ui/icons';
import {Accordion, AccordionSummary, AccordionDetails, Box, Card} from "@material-ui/core";
import FilterCardTitle from './common/filters/FilterCardTitle';
import { AlertComponent } from './components/alerts.js';
import { DisclaimerComponent } from './components/disclaimer.js';
import { LegendComponent } from './components/legend.js';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';
const moment = require('moment-timezone');


const choicesAdType = require('./components/adtypes.json');
const countryChoices = require('./components/countries.json');
const choicesSizes = require('./components/sizes.json');
const utils = require('./components/utils');
const dataSupport = require('./components/data_support.js');
const fetch = fetchUtils.fetchJson;


const BASE_URL = window.nobid_endpoint+'/auction_optimizer_report'
const requestOptions = {headers: new Headers()}
requestOptions.headers.set('accept', 'application/json')
const token = localStorage.getItem('token');
requestOptions.headers.set('Authorization', `Bearer ${token}`);

// https://github.com/jbetancur/react-data-table-component/blob/master/stories/DataTable/Basic/ExportCSV.stories.js
function convertArrayOfObjectsToCSV(array) {
  let result;

  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  let keys = Object.keys(array[0]);
  keys = keys.filter(key => (key!=='code' && key!=='adx_ad_requests' && key!=='id'));

  result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach(item => {
    let ctr = 0;
    keys.forEach(key => {
      if (key==='code' || key==='adx_ad_requests' || key==='id') return;
      if (ctr > 0) result += columnDelimiter;

      result += item[key];
      // eslint-disable-next-line no-plusplus
      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
}

function downloadCSV(array) {
  array.forEach((row, i) => {
    delete array[i].id
    delete array[i].code
  })
  dataSupport.exportData(array)
}

const carbonBidders = [
  { id: 'nobid', name: 'NoBid' },
  { id: 'appnexus', name: 'Appnexus' }
]

const choicesShow = [
  { id: 'created_at', name: 'Creation Date' },
  { id: 'period_start', name: 'Period Start' },
  { id: 'period_end', name: 'Period End' },
  { id: 'publisher', name: 'Publisher' },
  { id: 'site', name: 'Site' },
  { id: 'bidder', name: 'Bidder' },
  { id: 'country', name: 'Country' },
  // { id: 'device', name: 'Device' },
  // { id: 'browser', name: 'Browser' },
  // { id: 'ad_type', name: 'Ad Type' },
	{ id: 'adsize', name: 'Ad Size' },
]

const BASE_COLUMNS = [
  { name: 'Creation Date', selector: 'created_at', definition: 'Typically the Optimizer runs every hour and this column shows the date the record was created.' },
  { name: 'Period Start', selector: 'period_start', definition: 'The Optimizer start date selection.' },
  { name: 'Period End', selector: 'period_end', definition: 'The Optimizer start date selection.' },
  { name: 'Publisher', selector: 'publisher_name', sortable: true },
  { name: 'Site', selector: 'site_name', sortable: true },
  { name: 'Site ID', selector: 'site_id', sortable: true },
  { name: 'Bidder', selector: 'bidder_name', sortable: true },
  { name: 'Country', selector: 'country', sortable: true },
	{ name: 'Ad Size', selector: 'adsize', sortable: true },
  { name: 'Ad Type', selector: 'ad_type', sortable: true },
  { name: '#Impressions', selector: 'impressions', sortable: true, cell: row => <span>{ utils.formatLong(row.impressions) }</span>, definition: 'Impressions served.' },
  { name: '$Revenue', selector: 'revenue', sortable: true, cell: row => <span>{ utils.formatDouble(row.revenue) }</span>, definition: 'Revenue generated by the served impressions.' },
  { name: '$Avg CPM', selector: 'avg_cpm', sortable: true, cell: row => <span>{Number(Number.parseFloat(row.avg_cpm).toFixed(2))}</span>, definition: 'The Average CPM is defined as 1,000 * Revenue / Impressions.'},
  { name: '#Bid Requests', selector: 'bid_requests', sortable: true, cell: row => <span>{ utils.formatLong(row.bid_requests) }</span>, definition: 'The Bid Requests sent from the Prebid wrapper to the Demand sources defined in the Prebid wrapper.' },
  { name: '#Bid Responses', selector: 'bid_responses', sortable: true, cell: row => <span>{ utils.formatLong(row.bid_responses) }</span>, definition: 'The Bid Responses received by the Prebid wrapper from the Demand sources.' },
  { name: '$RPM Bid Requests', selector: 'rpm_bid_requests', sortable: true, cell: row => <span>{ utils.formatDouble(row.rpm_bid_requests) }</span>, definition: 'The Revenue Per Million Bid Requests is defined as 1,000,000 * Revenue / Bid Requests.' },
  { name: '$Net Profit', selector: 'net_profit', sortable: true, cell: row => <span>{ utils.formatDouble(row.net_profit) }</span>, definition: 'Net Profit is the differrence between Gross Revenue and Net Revenue and Technology Cost in US Dollars ($).' },
];

const defaultColumnSelectors = ['impressions', 'revenue', 'avg_cpm', 'bid_requests', 'bid_responses', 'bid_request_rate', 'bid_response_rate', 'net_profit', 'rpm_bid_requests'];

class CustomToolbar extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL
  };

  constructor(props) {
    super(props);
    this.parent = props.parent;
  }

  fetchData = () => {
    function updateState(that, headers, json) {
      if (json) for (let i in json) {
        let r = json[i];
        if (r.date) r.date = r.date.indexOf('T') > 0 ? r.date.substring(0, r.date.indexOf('T')) : r.date;
      }

      const showList = formData.show || [];
      const columnSelectors = defaultColumnSelectors.concat(showList.flatMap(x=>[x, `${x}_id`, `${x}_name`, `${x}_group`]));

      that.parent.setState({
        data: json,
        saved_data:json,
        columns: BASE_COLUMNS.filter(c => columnSelectors.includes(c.selector)),
        loading: false});
    }

    function formDataFields(formData, fields) {
      const buf = [];
      for(let i in fields) {
        let field = fields[i];
        if (formData[field] && Array.isArray(formData[field]) && formData[field].length>0) {
          formData[field].map(x => buf.push(`${field}=${x}`));
        } else if (formData[field]) {
          buf.push(`${field}=${formData[field]}`);
        }
      }
      return buf.length>0 ? `&${buf.join('&')}` : '';
    }

    formData.show = formData.show || [];
    let show='';
    if (formData.show) formData.show.forEach(item => { show+='&show='+item; });

    this.parent.setState({ loading: true });
    let url = `${this.state.baseUrl}?${show}` +
      `${formDataFields(
          formData,
          ['created_at', 'period_start', 'period_end', 'publisher_id', 'site_id', 'bidder', 'bidder_id',
          'ad_type', 'device', 'country', 'browser', 'adsize']
      )}`;
    const requestOptions = {headers: new Headers()}
    requestOptions.headers.set('accept', 'application/json')
    const token = localStorage.getItem('token');
    requestOptions.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, requestOptions).then(({ headers, json }) => {
    	updateState(this, headers, json)
    });
  }
  handleClick = () => {
	  this.fetchData();
  }

  render () {
    return (
      <Toolbar>
        <SaveButton style={{marginRight: '25px'}} variant='contained' 
          color='primary' disabled={this.parent.state.loading} {...this.props} />
        <Button label="Run Report" onClick={this.handleClick} props={this.props} variant="contained"
          style={{marginRight: '25px', padding: '7px', width: '160px'}} color="primary" startIcon={<RunReportIcon />} disabled={this.parent.state.loading}/>
      </Toolbar>
    )
  }
}

const CarbonizerReportTitle = ({ record }) => {
  return <span>Optimizer Report {record ? `"${record.name}"` : ''}</span>;
};

const AuctionOptimizerReportFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search_name" alwaysOn resettable />
  </Filter>
);

const Empty = () => {
  const { basePath, resource } = useListContext();
  return (
    <Box textAlign="center" m={1}>
      <Typography style={{marginTop: '150px'}} variant="h4" paragraph>
          No Auction Optimizer Reports available
      </Typography>
      <Typography variant="body1">
          Create one
      </Typography>
      <CreateButton style={{marginTop: '50px'}} basePath={basePath} variant='contained'/>
    </Box>
  );
};

export const AuctionOptimizerReportList = ({ permissions, ...props }) => (
  <List {...props} empty={<Empty />} title="Optimizer Reports" perPage={25} bulkActionButtons={false} filters={<AuctionOptimizerReportFilters />} 
  exporter={false} >
    <Datagrid rowClick="edit">
      <TextField source="name" label="Name" />
      <DateField source="updated_at" label="Update Date" />
      <DateField source="created_at" label="Creation Date" />
      <DeleteWithConfirmation {...props}/>
    </Datagrid>
  </List>
);

let formData = {};
function setFormData(formdata) {
  formData = formdata;
}

const hasActiveFilters = (record) => {
  const filters = ['publisher_id', 'site_id', 'bidder_name', 'country', 'adsize', 'ad_type', 'device', 'browser', 'tldomain'];
  return record && filters.some( f => record[f] && record[f].length > 0)
}

class CarbonizerReportComponent extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL,
    dateRange: this.props.record.date_range
  };

  render() {
    const { loading, data, dateRange } = this.state;
    const { permissions, formType, record } = this.props;

    return (
      <div>
        <AlertComponent />
        <Card>
          <SimpleForm toolbar={<CustomToolbar parent={this} />} style={{ width: '100%', backgroundColor: '#424242', borderRadius: '5px' }} {...this.props}>
            <TextInput source="name" label="Report Name" style={{ width: '400px' }} validate={required()} />
            <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper2">
              <FormDataConsumer>
                {({ formData }) => setFormData(formData) }
              </FormDataConsumer>
            </div>

            <Accordion defaultExpanded={true} style={{ marginBottom: '20px', backgroundColor: '#3e3e3e'}} fullWidth>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <FilterCardTitle title="Dimensions / Metrics" values={true} />
              </AccordionSummary>
              <AccordionDetails>
              <div style={{alignSelf: 'flex-start', width: '100%'}}>
                <SelectArrayInput label="Show"
                  size="small"
                  source="show" 
                  choices={choicesShow}
                  style={{alignSelf: 'flex-start', width: '100%'}}
                  disabled={loading} />
              </div>
              </AccordionDetails>
            </Accordion>
              
            <Accordion defaultExpanded={formType==="create"} style={{ marginBottom: '20px', backgroundColor: '#3e3e3e'}} fullWidth>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <FilterCardTitle title="Filters" values={hasActiveFilters(record)} />
              </AccordionSummary>
              <AccordionDetails>
                <Box style={{ width: '100%' }}>
                  <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper3">
                    <div style={{flex: 1}}>
                      <ReferenceArrayInput 
                        source="publisher_id" 
                        label="Publisher" 
                        reference="publishers"
                        basePath="publishers"
                        perPage={15} 
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        allowEmpty
                        disabled={loading}>
                        <AutocompleteArrayInput disabled={loading}
                          label="Publishers"
                          optionText="name"
                          optionValue="code"
                          fullWidth/>
                      </ReferenceArrayInput>
                    </div>

                    {permissions &&
                      <div style={{flex: 1}}>
                        <ReferenceArrayInput 
                          source="site_id" 
                          label="Site" 
                          reference="sites"
                          basePath='sites'
                          perPage={15} 
                          sort={{ field: 'name', order: 'ASC' }}
                          filterToQuery={searchText => ({ search_name: searchText })}
                          allowEmpty
                          disabled={loading}>
                          <AutocompleteArrayInput disabled={loading} label="Sites" 
                            optionText={(permissions.role==='admin' || permissions.role==='report_admin')?"adunit_path":"name"}
                            optionValue="code"
                            fullWidth/>
                        </ReferenceArrayInput>
                      </div>
                    }
                  
                    {permissions && ['admin', 'report_admin'].includes(permissions.role) &&
                      <div style={{flex: 1}}>
                        <ReferenceArrayInput 
                          source="bidder_id" 
                          label="Bidder" 
                          reference="bidders"
                          basePath='bidders'
                          sort={{ field: 'name', order: 'ASC' }}
                          filterToQuery={searchText => ({ search_name: searchText })}
                          allowEmpty
                          disabled={loading} >
                          <AutocompleteArrayInput label="Bidder" optionText={record => (record && record.name)?`${record.name} (${record.code})`:""}
                            optionValue="code" fullWidth/>
                        </ReferenceArrayInput>
                      </div>
                    }
                  </div>

                  <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} >
                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Countries"
                        source="country"
                        choices={countryChoices}
                        disabled={loading}
                        fullWidth/>
                    </div>
                    
										<div style={{flex: 1}}>
                      <SelectArrayInput label="Ad Sizes" 
                        source="adsize" 
                        choices={choicesSizes} 
                        disabled={loading}
                        fullWidth />
                    </div>

										<div style={{flex: 1}}>
											<SelectArrayInput label="Ad Type" 
												source="ad_type" 
												choices={choicesAdType}
												disabled={loading}
												fullWidth />    
                    </div>

                  </div>
                </Box>
              </AccordionDetails>
            </Accordion>
          </SimpleForm>
        </Card>
        <div style={{ height: '15px', backgroundColor: '#303030'}} />
        
        <Card>
          <DataTable
            title="Optimizer Report"
            theme="dark"
            columns={this.state.columns}
            data={data}
            progressPending={loading}
            pagination
            fixedHeader
            paginationPerPage={30}
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            dense
            highlightOnHover
            subHeader={!loading}
            subHeaderComponent={
              (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input type="text" id='search_box' label="Search" 
                  variant="outlined" 
                  style={{ margin: '5px' }} 
                  onChange={(target) => dataSupport.filterData(this)}/>
                  <CloudDownload 
                  label="Export"
                  style={{ margin: '5px' }} 
                  color="action" 
                  onClick={() => downloadCSV(this.state.data)}
                  />
                </div>
              )
            }
          />
          
          <DisclaimerComponent />

					<LegendComponent columns={BASE_COLUMNS} choices={choicesShow}/>

        </Card>
      </div>
    )
  }
};

export const AuctionOptimizerReportEdit = (props) => (
  <Edit title={<CarbonizerReportTitle />}  mutationMode="pessimistic" {...props}>
    <CarbonizerReportComponent formType="edit" permissions={props.permissions} {...props} />
  </Edit>
);

export const AuctionOptimizerReportCreate = (props) => (
  <Create title="Create Carbonizer Report" mutationMode="pessimistic" {...props}>
    <CarbonizerReportComponent formType="create" permissions={props.permissions} {...props} />
  </Create>
);
